import type { ApiClientOptions } from "./client";
import { createApiClient } from "./client";

export interface Notification {
  id: string;
  user_id: string;
  title: string;
  message: string;
  is_read: boolean;
  action_url: string | null;
  created_at: string;
  updated_at: string;
}

export function createNotificationsApi(options: ApiClientOptions) {
  const api = createApiClient(options);

  return {
    list: () => api.get<Notification[]>("/api/notifications"),
    markAsRead: (id: string) =>
      api.patch<Notification>(`/api/notifications/${id}/read`),
  };
}
